(function () {
  'use strict';
  var url = new URL(window.location.href);
  var match;
  try { match = decodeURIComponent(url.pathname).match(/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?collections\/all\/([^/+]+-(?:esi|esr)\d+)\/?$/i); } catch (_) { return; }
  if (!match || url.searchParams.has('section_id') || url.searchParams.has('sections')) return;
  var view = url.searchParams.get('view');
  if (view && view !== 'senfineco-spare-parts') return;
  var token = match[1].toLowerCase();
  var vehicleMatch = token.match(/^(.*?)-((?:19|20)\d{2})(?:-((?:19|20)\d{2}))?-(.+)-(?:esi|esr)\d+$/i);
  var makes = ['mercedes-benz','land-rover','chevrolet','chrysler','mitsubishi','infiniti','hyundai','genesis','toyota','nissan','lexus','honda','mazda','dodge','ford','jeep','kia','gmc','mg'];
  var make = vehicleMatch && makes.find(function (m) { return vehicleMatch[1].indexOf(m + '-') === 0; });
  if (make) {
    var title = function (s) { return s.split('-').map(function (w) { return w.charAt(0).toUpperCase() + w.slice(1); }).join(' '); };
    var result = new URL(url.href);
    result.searchParams.set('view', 'senfineco-spare-parts');
    result.searchParams.delete('page');
    result.hash = '';
    try {
      var prior = JSON.parse(localStorage.getItem('sfSparePartsVehicleV1') || 'null');
      var priorURL = prior && prior.resultsUrl ? new URL(prior.resultsUrl, location.origin) : null;
      var same = priorURL && decodeURIComponent(priorURL.pathname).split('/').filter(Boolean).pop() === token;
      if (!same) {
        var year = vehicleMatch[2] + (vehicleMatch[3] && vehicleMatch[3] !== vehicleMatch[2] ? '–' + vehicleMatch[3] : '');
        var engine = vehicleMatch[4].replace(/(\d)-(\d)l/gi, '$1.$2L').replace(/-/g, ' ').toUpperCase();
        var vehicle = {version:2,source:'easysearch',make:title(make),model:title(vehicleMatch[1].slice(make.length + 1)),year:year,engine:engine,resultsUrl:result.pathname + result.search,updatedAt:new Date().toISOString()};
        vehicle.values = [vehicle.make,vehicle.model,vehicle.year,vehicle.engine];
        vehicle.label = vehicle.values.join(' · ');
        localStorage.setItem('sfSparePartsVehicleV1', JSON.stringify(vehicle));
        ['sfSparePartsSavedRestoreV2','sfSparePartsReturnStateV3','sfBrandFirstMakeV1','sfBrandFirstRouteV1','sfBrandFirstFreshIntentV1'].forEach(function(k){sessionStorage.removeItem(k);});
      }
    } catch (_) {}
  }
  if (!view) {
    url.searchParams.set('view', 'senfineco-spare-parts');
    window.location.replace(url.pathname + url.search + url.hash);
  }
})();